(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7132],{

/***/ 26452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_modalStyle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13764);
/* harmony import */ var _Buttons_Buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3805);
/* harmony import */ var _OrderAlertModal_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17569);
/* harmony import */ var _OrderAlertModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_OrderAlertModal_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








function OrderAlertModal(_ref) {
  var alertText = _ref.alertText,
      isModalOpen = _ref.isModalOpen,
      modalLabel = _ref.modalLabel,
      _ref$continueBtnText = _ref.continueBtnText,
      continueBtnText = _ref$continueBtnText === void 0 ? 'Συνέχεια' : _ref$continueBtnText,
      callback = _ref.callback;
  var customStyles = {
    overlay: _objectSpread({}, _utils_modalStyle__WEBPACK_IMPORTED_MODULE_2__/* ["default"].overlay */ .Z.overlay),
    content: _objectSpread(_objectSpread({}, _utils_modalStyle__WEBPACK_IMPORTED_MODULE_2__/* ["default"].content */ .Z.content), {}, {
      width: '30.5rem',
      maxWidth: '100%'
    })
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)((react_modal__WEBPACK_IMPORTED_MODULE_1___default()), {
    isOpen: isModalOpen,
    style: customStyles,
    contentLabel: modalLabel,
    ariaHideApp: false,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: (_OrderAlertModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalContainer),
      "data-cy": "error-modal",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
        className: (_OrderAlertModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().text),
        children: alertText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_3__/* .PrimaryButton */ .KM, {
          onClick: callback,
          "data-cy": "alert-ok",
          children: continueBtnText
        })
      })]
    })
  });
}

/* harmony default export */ __webpack_exports__["default"] = (OrderAlertModal);

/***/ }),

/***/ 81052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Ethima; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(28833);
/* harmony import */ var _styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _api_Articles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62178);
/* harmony import */ var _components_CustomMetaHead__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92536);
/* harmony import */ var _components_Footer_Footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31875);
/* harmony import */ var _components_Header_Header__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3266);
/* harmony import */ var _components_LayoutDynamic_LayoutDynamic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56437);
/* harmony import */ var _components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86894);
/* harmony import */ var _components_OrderAlertModal_OrderAlertModal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26452);
/* harmony import */ var _components_Page_Title_PageTitle__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36593);
/* harmony import */ var _store_loader__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(58766);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85893);

















var __N_SSG = true;
function Ethima(_ref) {
  var navigation = _ref.navigation,
      footerLinks = _ref.footerLinks,
      appLinks = _ref.appLinks,
      categories = _ref.categories,
      query = _ref.query,
      meta = _ref.meta;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      ethima = _useState[0],
      setEthima = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      openModal = _useState2[0],
      setOpenModal = _useState2[1];

  var contentType = 'ethima';
  var _router$query = router.query,
      category = _router$query.category,
      page = _router$query.page;
  var ETHIMA_LOADER_EVENT = 'ETHIMA_LOADING';
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    _store_loader__WEBPACK_IMPORTED_MODULE_11__/* ["default"].addEvent */ .Z.addEvent(ETHIMA_LOADER_EVENT);

    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var _data$data;

        var _yield$getList, data, error;

        return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0,_api_Articles__WEBPACK_IMPORTED_MODULE_3__/* .getList */ .gp)(contentType, page, category);

              case 2:
                _yield$getList = _context.sent;
                data = _yield$getList.data;
                error = _yield$getList.error;

                if (!error) {
                  _context.next = 8;
                  break;
                }

                router.push('/404');
                return _context.abrupt("return");

              case 8:
                setEthima(data);
                _store_loader__WEBPACK_IMPORTED_MODULE_11__/* ["default"].removeEvent */ .Z.removeEvent(ETHIMA_LOADER_EVENT);

                if (data !== null && data !== void 0 && (_data$data = data.data) !== null && _data$data !== void 0 && _data$data.length) {
                  _context.next = 15;
                  break;
                }

                if (!category) {
                  _context.next = 14;
                  break;
                }

                setOpenModal(true);
                return _context.abrupt("return");

              case 14:
                router.push('/404');

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData();
  }, [category, page]);
  if (!ethima) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_CustomMetaHead__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      meta: meta
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
      className: (_styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().headerContainer),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_Header_Header__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        navigation: navigation
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        navigation: navigation
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_Page_Title_PageTitle__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      title: "\u0388\u03B8\u03B9\u03BC\u03B1 \u03C4\u03BF\u03C5 \u03C4\u03CC\u03C0\u03BF\u03C5 \u03BC\u03B1\u03C2"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_LayoutDynamic_LayoutDynamic__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      data: ethima,
      appLinks: appLinks,
      path: router.pathname,
      categories: categories,
      contentName: "ethima",
      query: query
    }), openModal && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_OrderAlertModal_OrderAlertModal__WEBPACK_IMPORTED_MODULE_9__["default"], {
      isModalOpen: openModal,
      callback: function callback() {
        setOpenModal(false);
        router.push("/".concat(contentType));
      },
      alertText: "\u0394\u03B5 \u03B2\u03C1\u03AD\u03B8\u03B7\u03BA\u03B1\u03BD \u03B1\u03C0\u03BF\u03C4\u03B5\u03BB\u03AD\u03C3\u03BC\u03B1\u03C4\u03B1 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B1 \u03C0\u03BF\u03C5 \u03AD\u03C7\u03B5\u03C4\u03B5 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03B9."
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      footerLinks: footerLinks
    })]
  });
}

/***/ }),

/***/ 4272:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ethima",
      function () {
        return __webpack_require__(81052);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17569:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"OrderAlertModal_modalContainer__tyEcV","text":"OrderAlertModal_text__V_YPc"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,6556,3253,3996,4843,9950,9067,9527,5657,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(4272); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);